<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <!--begin::Container-->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div
                  class="card card-custom gutter-b bg-transparent shadow-none border-0"
                >
                  <div
                    class="card-header align-items-center border-bottom-dark px-0"
                  >
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                        Инвентаризация
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="">
              <form @submit.prevent="downloadInventoryPDF">
                <div class="row">
                  <div class="col-2 form-group">
                    <multiselect
                      v-model="year"
                      :options="yearOptions"
                      placeholder="Год"
                      track-by="value"
                      label="label"
                      :allow-empty="false"
                      class=""
                    ></multiselect>
                  </div>
                </div>
                <div class="form-group">
                  <button type="submit" class="btn btn-primary text-nowrap">Создать акт инвентаризации</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  data() {
    return {
      year: null,
      yearOptions: [],
    };
  },
  methods: {
    generateYearOptions() {
      const currentYear = new Date().getFullYear();
      const yearOptions = [];
      for (let year = 2023; year <= currentYear; year++) {
        yearOptions.push({ value: year, label: year.toString() });
      }
      return yearOptions;
    },
    downloadInventoryPDF() {
      if (!this.year) {
        // Handle the case when the year is not selected
        return;
      }

      var token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob'
      };
      axios.get("/api/admin/stock/inventory?year=" + this.year.value, config)
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = 'Inventory_Report_' + this.year.value + '.pdf'
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(error => {
          console.error(error);
          // Handle error, e.g., show an alert to the user
        });
    },
  },
  mounted() {
    this.yearOptions = this.generateYearOptions();
  },
};
</script>
